import {useContext, useEffect, useState} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {useLocation} from "react-router-dom";

export default function SeoBlock() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext)

    const location = useLocation()

    useEffect(() => {
        if(!state.meta){
            return
        }
        const meta = state.meta
        meta.seo_text = undefined
        dispatch({type: ReducerActionType.SET_PARAM, paramName: 'meta', payload: meta})
    }, [location.pathname]);

    return (<>{state.meta?.seo_text && <section className="information">
        <div className="container">
            <div className="row">
                <div className="col">
                    <div >
                        <div className="information__text" dangerouslySetInnerHTML={{__html: state.meta.seo_text}}/>
                    </div>
                </div>
            </div>
        </div>
    </section>}</>)
}